import { RouteProps } from 'src/router';
import FeatureToggles from './FeatureToggles';
import PlatformVersions from './PlatformVersions';

export const routes: RouteProps[] = [
  {
    index: true,
    component: FeatureToggles,
    meta: {
      title: 'Feature Toggles',
    },
  },
  {
    path: 'approved-edge-version',
    component: PlatformVersions,
    meta: {
      title: 'Approved Edge Version',
    },
  },
];
